import { deserializeXY } from "../serialization";
import { SolidifiedMob } from "./solidifiedMob";

export class SolidifiedHorned extends SolidifiedMob {
	static key = "SolidifiedHorned";

	static deserialize(data: any): SolidifiedHorned {
		const b = new SolidifiedHorned(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
